export default __webpack_public_path__ + "static/media/codersartsLogo.dd100b27.png";